import store from '../store'
import find from 'lodash/find'
 
export function getFolderName(folderId) {	
	const state = store.getState()
	const folder= find(state.folders, {'id':folderId})
	
	if(folder){
		return folder.name
	}else return null

}

